module.exports = __webpack_public_path__ + "img/TZS09605.27de010b.jpeg";